import React from "react";
import { Link } from "react-router-dom";

const Locksmith = () => {
  return (
    <div className="min-h-screen bg-white">
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-coral-400 via-coral-500 to-navy-900 overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `repeating-linear-gradient(-45deg, transparent, transparent 35px, white 35px, white 37px)`,
            }}
          ></div>
        </div>

        <div className="relative container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl text-white">
            <div className="inline-block bg-white/20 backdrop-blur-sm border border-white/40 rounded-full px-6 py-2 mb-6">
              <span className="text-sm font-bold tracking-wide">
                24/7 EMERGENCY SERVICE
              </span>
            </div>
            <h1 className="text-5xl md:text-7xl font-black leading-none mb-6">
              Professional
              <br />
              Locksmith Services
            </h1>
            <p className="text-xl md:text-2xl text-white/90 mb-8 leading-relaxed">
              Fast, reliable locksmith services available any time, day or
              night.
            </p>
            <div className="flex flex-wrap gap-4">
              <a
                href="tel:03300545944"
                className="px-8 py-4 bg-white text-coral-500 font-bold rounded-xl hover:bg-gray-100 shadow-lg"
              >
                CALL NOW: 0330 054 5944
              </a>
              <Link
                to="/get-quote"
                className="px-8 py-4 bg-transparent border-2 border-white text-white font-bold rounded-xl hover:bg-white/10"
              >
                REQUEST SERVICE
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-black text-navy-900 mb-4">
              Our <span className="text-coral-500">Locksmith Services</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              {
                title: "Emergency Lockout",
                icon: "🚨",
                desc: "24/7 fast response for home, car, and office lockouts",
              },
              {
                title: "Lock Installation",
                icon: "🔧",
                desc: "New lock installation for residential and commercial properties",
              },
              {
                title: "Key Services",
                icon: "🔑",
                desc: "Key cutting, duplication, and replacement services",
              },
              {
                title: "Rekeying",
                icon: "🔄",
                desc: "Rekey existing locks for enhanced security",
              },
              {
                title: "Security Upgrades",
                icon: "🛡️",
                desc: "Advanced security systems and smart lock installation",
              },
              {
                title: "Safe Services",
                icon: "💼",
                desc: "Safe opening, installation, and combination changes",
              },
              {
                title: "Master Key Systems",
                icon: "🗝️",
                desc: "Custom master key solutions for businesses",
              },
              {
                title: "Broken Key Extraction",
                icon: "🔨",
                desc: "Professional removal of broken keys from locks",
              },
            ].map((service, index) => (
              <div
                key={index}
                className="bg-gray-50 rounded-2xl p-6 border-2 border-gray-200 hover:border-coral-400"
              >
                <div className="text-4xl mb-3">{service.icon}</div>
                <h3 className="text-xl font-bold text-navy-900 mb-2">
                  {service.title}
                </h3>
                <p className="text-gray-600 text-sm">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-navy-900 text-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <div className="text-6xl mb-6">⚡</div>
            <h2 className="text-4xl md:text-5xl font-black mb-6">
              <span className="text-coral-400">24/7 Emergency</span> Response
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              Locked out? We're here to help - any time, any day. Our mobile
              locksmiths arrive quickly with all the tools needed to get you
              back inside safely.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
              {[
                { stat: "< 30 Min", label: "Average Response Time" },
                { stat: "24/7", label: "Available Every Day" },
                { stat: "100%", label: "Licensed & Insured" },
              ].map((item, index) => (
                <div key={index} className="bg-navy-800 rounded-xl p-6">
                  <div className="text-4xl font-black text-coral-400 mb-2">
                    {item.stat}
                  </div>
                  <div className="text-gray-300">{item.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-r from-coral-400 to-coral-500">
        <div className="container mx-auto px-4 lg:px-8 text-center text-white">
          <h2 className="text-4xl md:text-5xl font-black mb-6">
            Need a Locksmith Right Now?
          </h2>
          <p className="text-xl mb-8">
            Don't wait - call now for immediate assistance
          </p>
          <a
            href="tel:03300545944"
            className="inline-block px-12 py-5 bg-navy-900 text-white font-black text-lg rounded-xl hover:bg-navy-800 shadow-2xl"
          >
            CALL: 0330 054 5944
          </a>
        </div>
      </section>
    </div>
  );
};

export default Locksmith;
